<template>
  <div>
    <h2 class="text-left alert" :class="[removed ? 'alert-danger' : 'alert-success']">
      Drug Allocations
      <a class="btn btn-sm" @click="$emit('onRemoveSection', stepName)">
        <span class="glyphicon" :class="[removed ? 'glyphicon-plus' : 'glyphicon-remove']"></span>
      </a>
    </h2>
    <template v-if="!removed">
      <subsection subsection="drug_allocations" title="Drug Allocations">
        <div v-for="(drug_group, groupIndex) in model.drug_groups" :key="`${drug_group.name}-${groupIndex}`">
          <dl class="dl-horizontal">
            <dt>{{ drug_group.name }}</dt>
            <report-comment
              :field_name="`heading_${slugify(drug_group.name)}`"
              :model="model.COMMENTS"
              :heading="false"
            ></report-comment>
          </dl>
        </div>
      </subsection>
    </template>
  </div>
</template>

<script>
import { slugify } from '@/_helpers/utils'
import mixin from './mixin'

export default {
  name: 'DrugAllocations',
  mixins: [mixin],
  methods: {
    slugify: slugify,
  },
}
</script>
